import { Component, OnInit, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-navbartop",
  templateUrl: "./navbartop.component.html",
  styleUrls: ["./navbartop.component.scss"]
})
export class NavbartopComponent implements OnInit {
  @Input() menuItems: any[]; // TODO MAKE THIS DINAMICALLY

  constructor(private translate: TranslateService) {}

  ngOnInit() {}

  changeLang(language: string) {
    this.translate.use(language);
  }
}
